<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>KRÉTA órarend-összevetés</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card>
    <ion-card-header>
      <ion-card-title>Összevetés</ion-card-title>
      <ion-card-subtitle>A tanár órarendje a KRÉTA-ban és nálunk — óráról órára</ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-note color="medium" class="ko-bevezeto">
        A régi KRÉTA-kapu köztes futtatóra épült: a hibái nem jutottak el hozzád, és nem
        lehetett megmondani, mi miért nem ment át. Ez a képernyő ugyanazt a belépést
        használja, amivel a <b>naplózás már élesben működik</b>, és először csak
        <b>ellenőriz</b>: megmutatja, hol tér el a két rendszer órarendje.
      </ion-note>

      <div class="ko-sor">
        <ion-select label="Tanár" labelPlacement="stacked" interface="popover"
                    placeholder="válassz kollégát" [(ngModel)]="allomany">
          <ion-select-option *ngFor="let t of tanarok" [value]="t.allomany" [disabled]="!t.aktiv">
            {{ t.nev }}<span *ngIf="!t.aktiv"> (kikapcsolva)</span>
          </ion-select-option>
        </ion-select>
        <ion-input label="Ettől" labelPlacement="stacked" fill="outline" type="date" [(ngModel)]="tol"></ion-input>
        <ion-input label="Eddig" labelPlacement="stacked" fill="outline" type="date" [(ngModel)]="ig"></ion-input>
        <ion-button color="primary" [disabled]="fut || !allomany" (click)="osszevet()">
          <ion-icon slot="start" name="git-compare-outline"></ion-icon>
          {{ fut ? 'Belépés és lekérés…' : 'Összevetés' }}
        </ion-button>
      </div>

      <!-- ── Tömeges ellenőrzés ────────────────────────────────────────────────
           Egyesével végigmenni húsz kollégán annyit jelentett, hogy húszszor kellett
           kiválasztani a nevet és megvárni a KRÉTA-belépést. -->
      <details class="ko-tomeges" *ngIf="tanarok.length">
        <summary>Tömeges ellenőrzés — több kolléga egy menetben</summary>
        <ion-note color="medium" class="ko-sugo">
          A KRÉTA-belépés kollégánként külön történik (a tanári kapu mindenkit a saját
          jelszavával enged be), ezért ez <b>percekig tarthat</b>. Egy kolléga hibája nem
          viszi el a többit: aki elbukik, külön listában szerepel az okkal.
        </ion-note>
        <div class="ko-tomeges-lista">
          <ion-button size="small" fill="outline" (click)="tomegesMind()">Mind / egyik sem</ion-button>
          <label *ngFor="let t of tanarok" class="ko-tomeges-elem" [class.ko-tiltott]="!t.aktiv">
            <input type="checkbox" [disabled]="!t.aktiv"
                   [checked]="tomegesKijelolt.has(t.allomany)" (change)="tomegesValt(t.allomany)" />
            {{ t.nev }}<span *ngIf="!t.aktiv"> (kikapcsolva)</span>
          </label>
        </div>
        <div class="ko-tomeges-gombok">
          <ion-button color="primary" [disabled]="tomegesFut || !tomegesKijelolt.size" (click)="tomegesOsszevet()">
            <ion-icon slot="start" name="git-compare-outline"></ion-icon>
            {{ tomegesFut ? 'Ellenőrzés fut…' : 'Ellenőrzés (' + tomegesKijelolt.size + ' kolléga)' }}
          </ion-button>
          <ion-button color="danger" fill="outline" *ngIf="tomegesFut" (click)="tomegesMegszakitas()">
            <ion-icon slot="start" name="stop-circle-outline"></ion-icon>
            Megszakítás
          </ion-button>
        </div>

        <!--  HALADÁS. A futás a kiszolgálón zajlik, ezért meg tudjuk mondani, hol tart:
              hányadik kollégánál, mióta nála, és mennyi telt el összesen. Enélkül a
              képernyő csak „töltött", és nem lehetett tudni, dolgozik-e vagy elakadt.  -->
        <div class="ko-halad" *ngIf="tomegesFut && tomegesEredmeny">
          <ion-progress-bar [value]="tomegesArany"></ion-progress-bar>
          <div class="ko-halad-sor">
            <b>{{ tomegesEredmeny.kesz }} / {{ tomegesEredmeny.osszes }}</b> kolléga kész
            <span *ngIf="tomegesEredmeny.jelenlegi">
              · éppen: <b>{{ tanarNev(tomegesEredmeny.jelenlegi) }}</b>
              ({{ ido(tomegesEredmeny.jelenlegi_ota_ms) }})
            </span>
            · eltelt {{ ido(tomegesEredmeny.eltelt_ms) }}
          </div>
          <ion-note color="medium">
            A KRÉTA-belépés kollégánként fél–egy perc; aki 4 percen belül sem válaszol, kimarad.
            Közben nyugodtan elnavigálhatsz, a futás nem áll meg — visszatérve újra ideáll.
          </ion-note>
        </div>
        <div class="ko-halad ko-halad-vege"
             *ngIf="!tomegesFut && tomegesEredmeny?.allapot === 'megszakitva'">
          Az ellenőrzést megszakítottad — {{ tomegesEredmeny.kesz }}/{{ tomegesEredmeny.osszes }}
          kolléga eredménye látszik.
        </div>

        <!--  A korlát miatt kimaradt kollégák. Nem elég egy buborék: a menet végéig
              látszania kell, kikkel nem történt semmi. -->
        <ion-note color="warning" class="ko-figyelmeztetes" *ngIf="tomegesEredmeny?.kimaradt?.length">
          <ion-icon name="alert-circle-outline"></ion-icon>
          {{ tomegesEredmeny.kimaradt.length }} kolléga NEM indult el: egy menetben legfeljebb
          {{ tomegesEredmeny.korlat }} fő ellenőrizhető (minden kollégánál külön KRÉTA-belépés
          történik). Őket egy következő menetben futtasd:
          <b>{{ tomegesEredmeny.kimaradt.join(', ') }}</b>
        </ion-note>

        <ng-container *ngIf="tomegesEredmeny?.tanarok?.length || tomegesEredmeny?.hibak?.length">
          <div class="ko-osszegzo">
            <div class="ko-kartya"><b>{{ tomegesEredmeny.tanarok.length }}</b><span>ellenőrizve</span></div>
            <div class="ko-kartya" [class.gond]="tomegesEredmeny.osszeg.elter">
              <b>{{ tomegesEredmeny.osszeg.elter }}</b><span>eltér</span></div>
            <div class="ko-kartya" [class.gond]="tomegesEredmeny.osszeg.csak_kretaban">
              <b>{{ tomegesEredmeny.osszeg.csak_kretaban }}</b><span>csak a KRÉTA-ban</span></div>
            <div class="ko-kartya" [class.gond]="tomegesEredmeny.osszeg.csak_nalunk">
              <b>{{ tomegesEredmeny.osszeg.csak_nalunk }}</b><span>csak nálunk</span></div>
            <div class="ko-kartya"><b>{{ tomegesEredmeny.osszeg.egyezo }}</b><span>egyezik</span></div>
            <div class="ko-kartya" [class.gond]="tomegesEredmeny.hibak.length">
              <b>{{ tomegesEredmeny.hibak.length }}</b><span>nem sikerült</span></div>
          </div>
          <!--  ÖSSZES ADAT ÁTVÉTELE MINDENKINEK — rögtön az összesítő alatt, hogy ne
                kelljen a táblázat végéig görgetni érte. A kiszolgáló a menetben eltett
                eredményből dolgozik: nincs újabb KRÉTA-belépés.  -->
          <div class="ko-lab-gombok" *ngIf="!tomegesFut && tomegesEredmeny.tanarok?.length">
            <ion-button color="secondary" [disabled]="tomegesAtvesz" (click)="tomegesAtvetel()">
              <ion-icon slot="start" name="cloud-download-outline"></ion-icon>
              {{ tomegesAtvesz ? 'Átvétel…' : 'Összes adat átvétele (mind a ' + tomegesEredmeny.tanarok.length + ' kolléga)' }}
            </ion-button>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="felulir" (change)="felulir = !felulir" />
              Meglévő órák felülírása
            </label>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="tantargyLetrehoz" (change)="tantargyLetrehoz = !tantargyLetrehoz" />
              Hiányzó tantárgy létrehozása
            </label>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="csoportLetrehoz" (change)="csoportLetrehoz = !csoportLetrehoz" />
              Hiányzó csoport létrehozása
            </label>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="teremLetrehoz" (change)="teremLetrehoz = !teremLetrehoz" />
              Hiányzó terem létrehozása
            </label>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="osztalyLetrehoz" (change)="osztalyLetrehoz = !osztalyLetrehoz" />
              Hiányzó osztály létrehozása
            </label>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="tagsag" (change)="tagsag = !tagsag" />
              Csoportok tagjai a KRÉTÁ-ból
            </label>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="feleslegesTorles" (change)="feleslegesTorles = !feleslegesTorles" />
              Feleslegessé vált órák törlése
            </label>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="torolIsmeretlen" (change)="torolIsmeretlen = !torolIsmeretlen" />
              A KRÉTA által nem ismert órák törlése
            </label>
          </div>
          <ion-note color="medium" class="ko-sugo" *ngIf="tantargyLetrehoz || csoportLetrehoz || teremLetrehoz || osztalyLetrehoz || tagsag">
            A KRÉTÁ-ban lévő, nálunk hiányzó <b>tantárgyat</b>, <b>csoportot</b>, <b>termet</b> és
            <b>osztályt</b> felvesszük az óra tanévébe — alapból mindet, egyenként kikapcsolható.
            Osztály csak egyértelmű osztálynévből („10/F") készül, a tanulóit és az osztályfőnökét
            az osztálykezelésben kell hozzárendelni. A csoport és a tantárgy <b>kötését</b> is
            pótoljuk. Tanárt nem hozunk létre.<br>
            A <b>csoportok tagjait</b> az átvétel végén a KRÉTA-csoporttükörből soroljuk be (Admin →
            Csoporttagság a KRÉTÁ-ból). Lezárás csak két napnál frissebb tükörből történik.<br>
            Vigyázz a <b>rövidített nevekkel</b>: a naptár olykor „dig.kult." alakban adja a
            tantárgyat, és abból külön tantárgy lesz a rendes mellé. Az új csoportnak az
            osztály-kötését a <b>neve alapján</b> próbáljuk pótolni („12/fgi/2/mt" → 12/F, 12/G,
            12/I) — enélkül az órái nem jelennének meg az osztály-órarendben.
          </ion-note>
          <ion-note color="medium" class="ko-sugo" *ngIf="feleslegesTorles">
            Ha a KRÉTÁ-ban <b>áthelyeztek</b> egy órát, nálunk nem új óra keletkezik: a meglévő
            sor <b>átköltözik</b> az új időpontba. Ami egy korábbi áthelyezésből már ott maradt
            (ugyanaz az óra kétszer), azt <b>töröljük</b>. Az áthelyezés <b>nem feltétlen napon
            belüli</b>: a hétfői óra átkerülhet szerdára, ezért nem a nap dönt, hanem a
            <b>darabszám</b> — tantárgy és osztály/csoport páronként annyi sort minősítünk
            feleslegesnek, amennyivel többünk van, mint amennyit a KRÉTA tud. Ha nincs
            többletünk, egyetlen sorhoz sem nyúlunk. A napló és a jegyek előbb <b>átkerülnek a
            párjára</b>; ami ütközik, az marad, és megmondjuk, miért.
          </ion-note>
          <ion-note color="medium" class="ko-sugo" *ngIf="torolIsmeretlen">
            A „csak nálunk" sorok azok, amikről a KRÉTA <b>egyáltalán nem tud</b> — nincs párjuk,
            amire a naplót át lehetne vezetni. Bepipálva <b>törölhetők</b>, de csak az
            <b>üresek</b>: amelyiken napló, hiányzás vagy jegy van, meghagyjuk, és tételesen
            kiírjuk, melyik az. Egy elveszett hiányzás visszaállíthatatlan, egy bent maradt üres
            sor viszont bármikor törölhető kézzel.
          </ion-note>
          <ion-note color="medium" class="ko-sugo" *ngIf="felulir">
            Felülírásnál a KRÉTA a mérvadó: az <b>egyező</b> órákat is átvesszük, és a meglévő
            óra osztálya/csoportja, tantárgya és terme a KRÉTA szerint lesz. A „csak nálunk"
            sorokhoz ettől még nem nyúlunk — azokhoz külön kapcsoló van.
          </ion-note>

          <table class="ko-tabla">
            <thead><tr><th>Kolléga</th><th>Csak a KRÉTA-ban</th><th>Csak nálunk</th><th>Eltér</th><th>Egyezik</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let s of tomegesEredmeny.tanarok">
                <td>{{ tanarNev(s.allomany) }}</td>
                <td [class.ko-gond]="s.csak_kretaban">{{ s.csak_kretaban }}</td>
                <td [class.ko-gond]="s.csak_nalunk">{{ s.csak_nalunk }}</td>
                <td [class.ko-gond]="s.elter">{{ s.elter }}</td>
                <td>{{ s.egyezo }}</td>
                <td>
                  <ion-button size="small" fill="clear" (click)="tomegesMegnyit(s)">Megnyitás</ion-button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="ko-atvetel" *ngIf="tomegesAtvetelEredmeny">
            <div class="ko-atvetel-fej">
              <b>{{ tomegesAtvetelEredmeny.osszeg.felvett }}</b> új óra ·
              <b>{{ tomegesAtvetelEredmeny.osszeg.frissitett }}</b> frissítve ·
              <b>{{ tomegesAtvetelEredmeny.osszeg.kihagyott }}</b> kihagyva
              <span class="ko-halvany" *ngIf="tomegesAtvetelEredmeny.felulir">· felülírással</span>
            <span *ngIf="tomegesAtvetelEredmeny.osszeg.tantargy_uj">·
              <b>{{ tomegesAtvetelEredmeny.osszeg.tantargy_uj }}</b> új tantárgy</span>
            <span *ngIf="tomegesAtvetelEredmeny.osszeg.osztaly_uj">·
              <b>{{ tomegesAtvetelEredmeny.osszeg.osztaly_uj }}</b> új osztály</span>
            <span *ngIf="tomegesAtvetelEredmeny.osszeg.kotes_uj">·
              <b>{{ tomegesAtvetelEredmeny.osszeg.kotes_uj }}</b> új csoport–tantárgy kötés</span>
            <div *ngIf="tomegesAtvetelEredmeny.osszeg.tagsag as t">
              Csoporttagság a KRÉTÁ-ból:
              <span *ngIf="t.nincs_tukor">nincs letöltött tükör (Admin → Csoporttagság a KRÉTÁ-ból → Letöltés)</span>
              <span *ngIf="t.hiba">hiba – {{ t.hiba }}</span>
              <span *ngIf="!t.nincs_tukor && !t.hiba"><b>{{ t.uj }}</b> tanuló besorolva {{ t.csoport }} csoportba<span *ngIf="t.lezaras">, {{ t.lezart }} tagság lezárva</span><span *ngIf="!t.lezaras"> – lezárás nem volt, mert a tükör {{ t.tukor_kora_nap }} napos</span><span *ngIf="t.parositatlan?.length"> · {{ t.parositatlan.length }} csoportnak nincs párja a tükörben</span></span>
            </div>
            </div>
            <table class="ko-tabla">
              <thead><tr><th>Kolléga</th><th>Új</th><th>Frissítve</th><th>Kihagyva</th><th>Órája az időszakban</th></tr></thead>
              <tbody>
                <tr *ngFor="let s of tomegesAtvetelEredmeny.tanarok">
                  <td>{{ tanarNev(s.allomany) }}</td>
                  <td>{{ s.felvett }}</td>
                  <td>{{ s.frissitett }}</td>
                  <td [class.ko-gond]="s.kihagyott">{{ s.kihagyott }}</td>
                  <td>{{ s.ellenorzes?.orak }}</td>
                </tr>
              </tbody>
            </table>
            <div class="ko-uzenetek" *ngFor="let s of tomegesAtvetelEredmeny.tanarok">
              <ng-container *ngIf="s.uzenetek?.length">
                <b>{{ tanarNev(s.allomany) }} — ami kimaradt:</b>
                <div *ngFor="let u of s.uzenetek">{{ u }}</div>
              </ng-container>
            </div>
          </div>

          <div class="ko-hiba-sor" *ngFor="let h of tomegesEredmeny.hibak">
            {{ tanarNev(h.allomany) }} — {{ h.ok }}
          </div>
          <ion-note color="medium" class="ko-sugo">{{ tomegesEredmeny.figyelmeztetes }}</ion-note>
        </ng-container>
      </details>

      <div class="ko-ures" *ngIf="!tanarok.length">
        Egyetlen kollégához sincs beállítva KRÉTA tanári hozzáférés. A hozzáféréseket a
        <b>KRÉTA naplózás</b> képernyőn (illetve a kolléga a saját <b>KRÉTA hozzáférésem</b>
        oldalán) lehet felvenni.
      </div>

      <div class="ko-hiba" *ngIf="hiba">
        <ion-icon name="alert-circle-outline"></ion-icon><span>{{ hiba }}</span>
      </div>

      <ng-container *ngIf="eredmeny">
        <!--  MIT KÉRDEZTÜNK LE. A tanári kapu két forrása nem ugyanazt tudja; ha a
              termek száma 0, az itt azonnal látszik.  -->
        <ion-note color="medium" class="ko-sugo" *ngIf="eredmeny.forras">
          A KRÉTA felől: {{ eredmeny.forras.osszes }} óra
          ({{ eredmeny.forras.nem_naplozott }} a nem naplózott listából,
          {{ eredmeny.forras.orarend }} a tanári órarendből), ebből
          {{ eredmeny.forras.termmel }} hozott termet is.
        </ion-note>
        <div class="ko-osszegzo">
          <div class="ko-kartya ok"><b>{{ eredmeny.osszegzo.egyezik }}</b><span>egyezik</span></div>
          <div class="ko-kartya figy"><b>{{ eredmeny.osszegzo.elter }}</b><span>eltér</span></div>
          <div class="ko-kartya baj"><b>{{ eredmeny.osszegzo.csak_kreta }}</b><span>csak a KRÉTA-ban</span></div>
          <div class="ko-kartya"><b>{{ eredmeny.osszegzo.csak_sulinform }}</b><span>csak nálunk</span></div>
        </div>

        <ion-note color="warning" class="ko-figyelmeztetes">
          <ion-icon name="information-circle-outline"></ion-icon>
          {{ eredmeny.figyelmeztetes }}
        </ion-note>

        <div class="ko-szurok">
          <ion-chip *ngFor="let k of ['elter','athelyezve','felesleges','csak_kreta','csak_sulinform','egyezik']"
                    [outline]="!szurok[k]" (click)="szurok[k] = !szurok[k]">
            {{ allapotSzoveg(k) }}
          </ion-chip>
        </div>

        <div class="ko-tabla-burok" *ngIf="szurtTetelek.length">
          <table class="ko-tabla">
            <thead>
              <tr>
                <th class="ko-pipa"><ion-checkbox (ionChange)="mindKijelol()" aria-label="Mind"></ion-checkbox></th>
                <th>Nap</th>
                <th class="szam">Óra</th>
                <th>KRÉTA</th>
                <th>Nálunk</th>
                <th>Állapot</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of szurtTetelek" [class]="'allapot-' + t.allapot">
                <td class="ko-pipa">
                  <ion-checkbox *ngIf="atvehetoE(t)" [checked]="kijeloltE(t)"
                                (ionChange)="kijelolValt(t)" aria-label="Kijelölés"></ion-checkbox>
                </td>
                <td>{{ t.datum }}</td>
                <td class="szam">{{ t.ora }}.</td>
                <td>
                  <span *ngIf="t.kreta"><b>{{ t.kreta.osztaly }}</b> — {{ t.kreta.tantargy }}</span>
                  <span class="ko-nincs" *ngIf="!t.kreta">—</span>
                </td>
                <td>
                  <span *ngIf="t.sajat"><b>{{ t.sajat.osztaly }}</b> — {{ t.sajat.tantargy }}</span>
                  <span class="ko-nincs" *ngIf="!t.sajat">—</span>
                </td>
                <td>
                  <span class="ko-jel" [class.ok]="t.allapot === 'egyezik'"
                        [class.figy]="t.allapot === 'elter' || t.allapot === 'athelyezve'"
                        [class.baj]="t.allapot === 'csak_kreta' || t.allapot === 'felesleges'">
                    {{ allapotSzoveg(t.allapot) }}<span *ngIf="t.elteres?.length"> ({{ t.elteres.join(', ') }})</span>
                  </span>
                  <!--  Ugyanaz a tantárgy, csak más néven: kötés, nem átírás. -->
                  <button *ngIf="kothetoE(t)" type="button" class="ko-kotes" [disabled]="kotesFut === t.kulcs"
                          (click)="tantargyKotes(t)" title="A KRÉTA-név a mi tantárgyunkat jelenti – az óra a helyén marad">
                    {{ kotesFut === t.kulcs ? 'Kötés…' : 'Tantárgy kötése' }}
                  </button>
                  <!--  Áthelyezésnél a honnan-hová a lényeg: enélkül a sor csak annyit
                        mondana, hogy „eltérés", és nem derülne ki, hogy ugyanarról az
                        óráról van szó. -->
                  <span class="ko-halvany" *ngIf="t.allapot === 'athelyezve' && t.honnan">
                    <br>innen: {{ t.honnan.datum }} {{ t.honnan.ora }}. óra
                  </span>
                  <span class="ko-halvany" *ngIf="t.allapot === 'felesleges' && t.parja">
                    <br>a párja: {{ t.parja.datum }} {{ t.parja.ora }}. óra — ez a sor törölhető
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="ko-ures" *ngIf="!szurtTetelek.length">
          A kiválasztott szűrőkkel nincs megjeleníthető óra.
        </div>

        <div class="ko-lab">
          <div class="ko-lab-szoveg">
            <b>{{ kijelolt.size }}</b> óra kijelölve átvételre a KRÉTA-ból.
            <div class="ko-irany">
              <b>Az áttöltés iránya nem szimmetrikus.</b> A KRÉTA felől át tudjuk venni az
              órákat az órarendünkbe. Visszafelé a tanári kapunak <b>nincs órarend-író
              végpontja</b> — ott a megtartott óra <b>naplózása</b> az, amit tenni lehet,
              és azt a KRÉTA naplózás képernyő végzi. A „csak nálunk" sorokat ezért
              megjelöljük, de nem küldjük át.
            </div>
          </div>
          <div class="ko-lab-gombok">
            <ion-button color="primary" [disabled]="atvesz || !kijelolt.size" (click)="atvetel()">
              <ion-icon slot="start" name="download-outline"></ion-icon>
              {{ atvesz ? 'Átvétel…' : 'Kijelöltek átvétele' }}
            </ion-button>
            <!--  ÖSSZES ADAT ÁTVÉTELE: kijelölgetés nélkül minden átvehető óra.  -->
            <ion-button color="secondary" [disabled]="atvesz" (click)="atvetel(true)">
              <ion-icon slot="start" name="cloud-download-outline"></ion-icon>
              Összes adat átvétele
            </ion-button>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="felulir" (change)="felulir = !felulir" />
              Meglévő órák felülírása
            </label>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="tantargyLetrehoz" (change)="tantargyLetrehoz = !tantargyLetrehoz" />
              Hiányzó tantárgy létrehozása
            </label>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="csoportLetrehoz" (change)="csoportLetrehoz = !csoportLetrehoz" />
              Hiányzó csoport létrehozása
            </label>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="teremLetrehoz" (change)="teremLetrehoz = !teremLetrehoz" />
              Hiányzó terem létrehozása
            </label>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="osztalyLetrehoz" (change)="osztalyLetrehoz = !osztalyLetrehoz" />
              Hiányzó osztály létrehozása
            </label>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="tagsag" (change)="tagsag = !tagsag" />
              Csoportok tagjai a KRÉTÁ-ból
            </label>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="feleslegesTorles" (change)="feleslegesTorles = !feleslegesTorles" />
              Feleslegessé vált órák törlése
            </label>
            <label class="ko-felulir">
              <input type="checkbox" [checked]="torolIsmeretlen" (change)="torolIsmeretlen = !torolIsmeretlen" />
              A KRÉTA által nem ismert órák törlése
            </label>
          </div>
        </div>

        <!--  AZ ÁTVÉTEL EREDMÉNYE. Marad a képernyőn: enélkül csak egy eltűnő buborék
              mondta meg, mi történt — és ha minden kimaradt, a felhasználó azt látta,
              hogy „nem történt semmi".  -->
        <div class="ko-atvetel" *ngIf="atvetelEredmeny">
          <div class="ko-atvetel-fej">
            <b>{{ atvetelEredmeny.felvett || 0 }}</b> új óra ·
            <b>{{ atvetelEredmeny.frissitett || 0 }}</b> frissítve ·
            <b>{{ atvetelEredmeny.kihagyott || 0 }}</b> kihagyva
            <span class="ko-halvany">({{ atvetelEredmeny.kert }} órát küldtünk át)</span>
            <span *ngIf="atvetelEredmeny.tantargy_uj">· <b>{{ atvetelEredmeny.tantargy_uj }}</b> új tantárgy</span>
            <!--  VISSZAOLVASVA az órarendből: erre a kérdésre — „tényleg beírta?" —
                  eddig csak a saját számlálónk válaszolt.  -->
            <span class="ko-visszaolvas" *ngIf="atvetelEredmeny.ellenorzes">
              Az órarendben most <b>{{ atvetelEredmeny.ellenorzes.orak }}</b> órája van
              ebben az időszakban ({{ atvetelEredmeny.ellenorzes.tol }} – {{ atvetelEredmeny.ellenorzes.ig }}).
            </span>
            <ion-button size="small" fill="outline" (click)="ujraEllenoriz()" [disabled]="fut">
              {{ fut ? 'Ellenőrzés…' : 'Újraellenőrzés' }}
            </ion-button>
          </div>
          <div class="ko-uzenetek" *ngIf="atvetelEredmeny.uzenetek?.length">
            <b>Ami kimaradt, és miért:</b>
            <div *ngFor="let u of atvetelEredmeny.uzenetek">{{ u }}</div>
          </div>
          <ion-note color="medium" *ngIf="!atvetelEredmeny.felvett && !atvetelEredmeny.frissitett">
            Egyetlen óra sem került be. A leggyakoribb ok, hogy a KRÉTA osztály-,
            csoport- vagy tantárgyneve nincs meg a törzsadatban — törzsadatot ugyanis
            <b>nem hozunk létre</b> a KRÉTA neve alapján.
          </ion-note>
        </div>

        <div class="ko-uzenetek" *ngIf="eredmeny.uzenetek?.length">
          <b>Ami kimaradt:</b>
          <div *ngFor="let u of eredmeny.uzenetek">{{ u }}</div>
        </div>
      </ng-container>
    </ion-card-content>
  </ion-card>
</ion-content>
